"use client"

import React from 'react';

const DemoVideoSection: React.FC = () => {
  return (
    <section className='bg-[#F8F5FF] py-24'>
      <div className='max-w-6xl mx-auto px-6 sm:px-8'>
        <h2 className='section-title'>Takeoff in Action</h2>
        <div className='max-w-5xl mx-auto'>
          <div className='w-full overflow-hidden rounded-xl border-2 border-[#1A1A1A] shadow-[8px_8px_0px_0px_rgba(26,26,26,1)]'>
            <video
              autoPlay
              loop
              muted
              playsInline
              className='w-full h-full object-contain bg-[#1A1A1A]'
              onLoadedMetadata={(e) => {
                e.currentTarget.playbackRate = 1.75;
              }}
            >
              <source src='/demo.mp4' type='video/mp4' />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoVideoSection; 